// modules
import CommonModule from "@/store/modules/common";

// interfaces
import { ICountry } from "@/interfaces/_shared/common";

interface IRawData {
  getRaw(fieldName: string): string; // Returns the HTML-unsafe raw value for a field, if it exists
  getSnippet(fieldName: string): string; // Returns the HTML-safe snippet value for a field, if it exists
}

/**
 * Use this model for customers data
 *
 * @class
 */
export default class CustomersModel implements ICustomerModel {
  private _rawData: IRawData;

  constructor(data: IRawData) {
    this._rawData = data;
  }

  /**
   * Get country
   *
   * @returns {string}
   */
  public get country(): string {
    return this._rawData.getRaw("country") || "";
  }

  /**
   * Get city
   *
   * @returns {string}
   */
  public get city(): string {
    return this._rawData.getRaw("city") || "";
  }

  /**
   * Get zip code
   *
   * @returns {string}
   */
  public get zipCode(): string {
    return this._rawData.getRaw("zip_code") || "";
  }

  /**
   * Get country string
   *
   * @returns {string}
   */
  public get countryString(): string {
    const country =
      CommonModule.countries.find(
        (item: ICountry) => item.code === this.country
      ) || ({} as ICountry);

    return country.name;
  }

  /**
   * Get email
   *
   * @returns {string}
   */
  public get email(): string {
    return this._rawData.getRaw("email") || "";
  }

  /**
   * Get groups
   *
   * @returns {string[]}
   */
  /*
  public get groupAccess(): string[] {
    return this._rawData.getRaw("group_access");
  }
*/

  /**
   * Get id
   *
   * @returns {string}
   */
  public get id(): string {
    return this._rawData.getRaw("id");
  }

  /**
   * Get uuid
   *
   * @returns {string}
   */
  public get uuid(): string {
    return this._rawData.getRaw("uuid") || "";
  }

  /**
   * Get phone
   *
   * @returns {string}
   */
  public get phone(): string {
    return this._rawData.getRaw("phone") || "";
  }

  /**
   * Get birthDate
   *
   * @returns {string}
   */
  public get birthDate(): string {
    return this._rawData.getRaw("birth_date") || "";
  }

  /**
   * Get marketingOptIn
   *
   * @returns {string}
   */
  public get emailMarketingOrganiser(): number {
    return this._rawData.getRaw("email_marketing_organiser") ? 1 : 0;
  }

  /**
   * Get full name
   *
   * @returns {string}
   */
  public get fullName(): string {
    return this._rawData.getRaw("full_name") || "";
  }

  /**
   * Get full name
   *
   * @returns {string}
   */
  public get firstName(): string {
    return this._rawData.getRaw("first_name") || "";
  }

  /**
   * Get full name
   *
   * @returns {string}
   */
  public get lastName(): string {
    return this._rawData.getRaw("last_name") || "";
  }

  /**
   * Get company
   *
   * @returns {string}
   */
  public get company(): string {
    return this._rawData.getRaw("company") || "";
  }

  /**
   * Get address
   *
   * @returns {string}
   */
  public get address(): string {
    return this._rawData.getRaw("address") || "";
  }

  /**
   * Get allergies
   *
   * @returns {string}
   */
  public get allergies(): string {
    return this._rawData.getRaw("allergies") || "";
  }

  /**
   * Get language
   *
   * @returns {string}
   */
  public get language(): string {
    return this._rawData.getRaw("language") || "";
  }

  /**
   * Get title
   *
   * @returns {string}
   */
  public get title(): string {
    return this._rawData.getRaw("title") || "";
  }
}

export interface ICustomerModel {
  country: string;
  countryString: string;
  email: string;
  // groupAccess: string[];
  id: string;
  uuid: string;
  phone: string;
  fullName: string;
  city: string;
  zipCode: string;
  company: string;
  address: string;
  allergies: string;
  language: string;
  title: string;
  emailMarketingOrganiser: number;
  birthDate: string;
}

export const MAP_ATTRIBUTES: {
  country: string;
  countryString: string;
  email: string;
  // groupAccess: "group_access",
  id: string;
  uuid: string;
  phone: string;
  fullName: string;
  city: string;
  zipCode: string;
  company: string;
  address: string;
  allergies: string;
  language: string;
  title: string;
  emailMarketingOrganiser: string;
  birthDate: string;
} = {
  country: "country",
  countryString: "country",
  email: "email",
  // groupAccess: "group_access",
  id: "id",
  uuid: "uuid",
  phone: "phone",
  fullName: "full_name",
  city: "city",
  zipCode: "zip_code",
  company: "company",
  address: "address",
  allergies: "allergies",
  language: "language",
  title: "title",
  emailMarketingOrganiser: "email_marketing_organiser",
  birthDate: "borth_date",
};
